import { alpha, Theme } from '@mui/material/styles'

export type AttendanceLayoutVariant = 'dialog' | 'page'

export const attendanceDialogBodySx = {
	maxHeight: '70vh',
	display: 'flex',
	flexDirection: 'column',
}

export const attendancePageBodySx = {
	display: 'flex',
	flexDirection: 'column',
	px: 2,
	pt: 1,
	pb: 0,
}

export const attendanceSignOnTableContainerSx = (variant: AttendanceLayoutVariant) => ({
	flex: 1,
	overflow: 'auto',
	...(variant === 'page' && {
		border: 1,
		borderColor: 'divider',
		borderRadius: 1,
		bgcolor: 'background.paper',
	}),
})

export const attendanceSignOutTableContainerSx = (variant: AttendanceLayoutVariant) => ({
	flex: 1,
	overflow: 'auto',
	...(variant === 'dialog'
		? { maxHeight: '25rem' }
		: {
				border: 1,
				borderColor: 'divider',
				borderRadius: 1,
				bgcolor: 'background.paper',
		  }),
})

export const attendanceCardPanelHeightSx = (variant: AttendanceLayoutVariant) =>
	variant === 'dialog' ? { maxHeight: '60vh', height: '60vh' } : { flex: 1, minHeight: 0, height: '100%' }

export const attendanceCardBodySx = (theme: Theme, variant: AttendanceLayoutVariant) => ({
	p: 3,
	background: alpha(theme.palette.grey[100], 0.3),
	...(variant === 'page' && {
		flex: 1,
		minHeight: 0,
		display: 'flex',
		flexDirection: 'column',
	}),
})

export const attendanceCardGridSx = (variant: AttendanceLayoutVariant) =>
	variant === 'page' ? { flex: 1, minHeight: 0, height: '100%' } : undefined
